"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const List_1 = __importDefault(require("@material-ui/core/List"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const stateFunctions_1 = require("../../domain/stateFunctions");
const changeSidePanel_1 = require("../../actions/app/changeSidePanel");
const UserListItem_1 = __importDefault(require("../shared/UserListItem"));
const users_1 = require("../../domain/model/users");
const gotoUser_1 = require("../../actions/chats/gotoUser");
const removeParticipant_1 = __importDefault(require("../../actions/chats/removeParticipant"));
const Header_1 = __importDefault(require("./Header"));
const CreateGroupChatIcon_1 = __importDefault(require("../shared/CreateGroupChatIcon"));
const panels_1 = require("../../domain/model/panels");
exports.default = react_1.default.memo(ParticipantsPanel);
const useStyles = makeStyles_1.default((theme) => ({
    list: {
        overflowX: "hidden",
        overflowY: "auto"
    },
    listItem: {
        "&:hover": {
            backgroundColor: theme.colors.sidePanel.listItemHoverBackgroundColor,
            cursor: "pointer"
        }
    }
}));
function ParticipantsPanel() {
    const dispatch = react_redux_1.useDispatch();
    const chat = react_redux_1.useSelector((state) => stateFunctions_1.getSelectedChat(state.chatsState));
    const me = react_redux_1.useSelector((state) => state.usersState.me);
    const _users = react_redux_1.useSelector((state) => stateFunctions_1.getUsers(chat.participants, state.usersState.userDictionary), compareUsers);
    // Sort participants alphabetically by username
    const users = _users.map(users_1.fromUserSummary);
    users.sort(users_1.compareUsersOnlineFirst);
    function closePanel() {
        dispatch(changeSidePanel_1.changeRightPanel(panels_1.RightPanelType.None));
    }
    const handleSelectUser = (user) => () => {
        if (user.userId != me.userId && user.chatId) {
            closePanel();
            dispatch(gotoUser_1.gotoKnownUser(user.userId));
        }
    };
    function compareUsers(left, right) {
        if (left.length !== right.length)
            return false;
        for (let i = 0; i < left.length; i++) {
            const l = left[i];
            const r = right[i];
            if (l.userId !== r.userId || l.username !== r.username || l.imageId !== r.imageId) {
                return false;
            }
        }
        return true;
    }
    const classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, { title: "Participants", onCloseButtonClick: closePanel }),
        react_1.default.createElement(List_1.default, { disablePadding: true, className: classes.list },
            react_1.default.createElement(ListItem_1.default, { onClick: _ => dispatch(changeSidePanel_1.changeRightPanel(panels_1.RightPanelType.AddParticipants)), className: classes.listItem, divider: true },
                react_1.default.createElement(ListItemIcon_1.default, null,
                    react_1.default.createElement(CreateGroupChatIcon_1.default, { size: "sm" })),
                react_1.default.createElement(Typography_1.default, { variant: "body1" }, "Add participant")),
            react_1.default.createElement(UserListItem_1.default, { key: me.userId, user: users_1.fromMyProfile(me) }),
            users.map(user => {
                const userId = user.userId;
                const buttons = [];
                buttons.push({ text: "Remove", action: () => dispatch(removeParticipant_1.default(chat.chatId, userId)) });
                buttons.push({ text: "Dismiss as admin", action: () => { } });
                return react_1.default.createElement(UserListItem_1.default, { key: userId, user: user, buttons: buttons, handleSelectUser: handleSelectUser(user) });
            }))));
}
